/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Care Club API - ASP.NET 8 - DEVELOPMENT (Local)
 * The Care Club API is a comprehensive backend service developed using ASP.NET 8. It facilitates seamless data access and interaction for services requiring information from the Care Club system. This API is designed to provide secure, reliable, and efficient access to member and service data, ensuring that all dependent applications can operate smoothly.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CareClubCCMAPIModelsDtoDirectDebitRequestDto,
  MicrosoftAspNetCoreMvcOkResult,
  PostApiGoCardlessGoCardlessSubscriptionsByParamsParams,
  RightioGoCardlessAPIWrapperModelsCommonErrorResponse,
  RightioGoCardlessAPIWrapperModelsCreateDirectDebitResponse,
  RightioGoCardlessAPIWrapperModelsDtoBankAccountDto,
  RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto,
  RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto,
  RightioGoCardlessAPIWrapperModelsDtoCustomerDto,
  RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto,
  RightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto,
  RightioGoCardlessAPIWrapperModelsDtoEventDto,
  RightioGoCardlessAPIWrapperModelsDtoMandateDto,
  RightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto,
  RightioGoCardlessAPIWrapperModelsDtoMandateRequestDto,
  RightioGoCardlessAPIWrapperModelsDtoPaymentDto,
  RightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto,
  RightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto,
  RightioGoCardlessAPIWrapperModelsDtoRefundDto,
  RightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto,
  RightioGoCardlessAPIWrapperModelsDtoSubscriptionDto,
  RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto,
  RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto
} from '../../model';

import { customInstance } from '../../../../../services/CCMAccess/index';
import type { ErrorType , BodyType } from '../../../../../services/CCMAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Retrieves a list of customers from the database
 * @summary Get a list of customers
 */
export const getApiGoCardlessGoCardlessCustomers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoCustomerDto[]>(
      {url: `/api/GoCardless/GoCardless/Customers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessCustomersQueryKey = () => {
    return [`/api/GoCardless/GoCardless/Customers`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomers>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessCustomersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomers>>> = ({ signal }) => getApiGoCardlessGoCardlessCustomers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomers>>>
export type GetApiGoCardlessGoCardlessCustomersQueryError = ErrorType<void>


/**
 * @summary Get a list of customers
 */

export function useGetApiGoCardlessGoCardlessCustomers<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomers>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessCustomersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new customer and returns the created customer
 * @summary Creates a new customer
 */
export const postCustomer = (
    rightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoCustomerDto>(
      {url: `/api/GoCardless/GoCardless/Customers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto, signal
    },
      options);
    }
  


export const getPostCustomerMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomer>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomer>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>}, TContext> => {

const mutationKey = ['postCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomer>>, {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postCustomer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomer>>>
    export type PostCustomerMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>
    export type PostCustomerMutationError = ErrorType<void>

    /**
 * @summary Creates a new customer
 */
export const usePostCustomer = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomer>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCustomer>>,
        TError,
        {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostCustomerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Returns a CustomerDto object
 * @summary Get a customer by their Id
 */
export const getApiGoCardlessGoCardlessCustomersId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoCustomerDto>(
      {url: `/api/GoCardless/GoCardless/Customers/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessCustomersIdQueryKey = (id: string,) => {
    return [`/api/GoCardless/GoCardless/Customers/${id}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessCustomersIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomersId>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomersId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessCustomersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomersId>>> = ({ signal }) => getApiGoCardlessGoCardlessCustomersId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomersId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessCustomersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomersId>>>
export type GetApiGoCardlessGoCardlessCustomersIdQueryError = ErrorType<void>


/**
 * @summary Get a customer by their Id
 */

export function useGetApiGoCardlessGoCardlessCustomersId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomersId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessCustomersId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessCustomersIdQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates a customer with the given information
 * @summary Updates a customer
 */
export const putApiGoCardlessGoCardlessCustomersId = (
    id: string,
    rightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoCustomerDto>(
      {url: `/api/GoCardless/GoCardless/Customers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto
    },
      options);
    }
  


export const getPutApiGoCardlessGoCardlessCustomersIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessCustomersId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessCustomersId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>}, TContext> => {

const mutationKey = ['putApiGoCardlessGoCardlessCustomersId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessCustomersId>>, {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiGoCardlessGoCardlessCustomersId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiGoCardlessGoCardlessCustomersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessCustomersId>>>
    export type PutApiGoCardlessGoCardlessCustomersIdMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>
    export type PutApiGoCardlessGoCardlessCustomersIdMutationError = ErrorType<void>

    /**
 * @summary Updates a customer
 */
export const usePutApiGoCardlessGoCardlessCustomersId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessCustomersId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiGoCardlessGoCardlessCustomersId>>,
        TError,
        {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>},
        TContext
      > => {

      const mutationOptions = getPutApiGoCardlessGoCardlessCustomersIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Returns a list of all bank accounts in the system
 * @summary Gets a list of all bank accounts
 */
export const getBankAccounts = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoBankAccountDto[]>(
      {url: `/api/GoCardless/GoCardless/BankAccounts`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBankAccountsQueryKey = () => {
    return [`/api/GoCardless/GoCardless/BankAccounts`] as const;
    }

    
export const getGetBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccounts>>> = ({ signal }) => getBankAccounts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccounts>>>
export type GetBankAccountsQueryError = ErrorType<string>


/**
 * @summary Gets a list of all bank accounts
 */

export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBankAccountsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new Bank Account and returns the newly created Bank Account
 * @summary Creates a new Bank Account
 */
export const postBankAccount = (
    rightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoBankAccountDto>(
      {url: `/api/GoCardless/GoCardless/BankAccounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto, signal
    },
      options);
    }
  


export const getPostBankAccountMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBankAccount>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postBankAccount>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto>}, TContext> => {

const mutationKey = ['postBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBankAccount>>, {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postBankAccount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof postBankAccount>>>
    export type PostBankAccountMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto>
    export type PostBankAccountMutationError = ErrorType<string>

    /**
 * @summary Creates a new Bank Account
 */
export const usePostBankAccount = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBankAccount>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postBankAccount>>,
        TError,
        {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostBankAccountMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Returns a list of all bank accounts for a given customer
 * @summary Gets a list of all bank accounts for a given customer
 */
export const getBankAccountsByCustomerId = (
    customerId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoBankAccountDto[]>(
      {url: `/api/GoCardless/GoCardless/BankAccounts/ByCustomerId/${customerId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBankAccountsByCustomerIdQueryKey = (customerId: string,) => {
    return [`/api/GoCardless/GoCardless/BankAccounts/ByCustomerId/${customerId}`] as const;
    }

    
export const getGetBankAccountsByCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccountsByCustomerId>>, TError = ErrorType<string>>(customerId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByCustomerId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsByCustomerIdQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccountsByCustomerId>>> = ({ signal }) => getBankAccountsByCustomerId(customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByCustomerId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBankAccountsByCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccountsByCustomerId>>>
export type GetBankAccountsByCustomerIdQueryError = ErrorType<string>


/**
 * @summary Gets a list of all bank accounts for a given customer
 */

export function useGetBankAccountsByCustomerId<TData = Awaited<ReturnType<typeof getBankAccountsByCustomerId>>, TError = ErrorType<string>>(
 customerId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankAccountsByCustomerId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBankAccountsByCustomerIdQueryOptions(customerId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves a Bank Account object by its Id
 * @summary Retrieves a Bank Account by its Id
 */
export const getBankAccount = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoBankAccountDto>(
      {url: `/api/GoCardless/GoCardless/BankAccounts/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBankAccountQueryKey = (id: string,) => {
    return [`/api/GoCardless/GoCardless/BankAccounts/${id}`] as const;
    }

    
export const getGetBankAccountQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccount>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankAccount>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccount>>> = ({ signal }) => getBankAccount(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBankAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccount>>>
export type GetBankAccountQueryError = ErrorType<void>


/**
 * @summary Retrieves a Bank Account by its Id
 */

export function useGetBankAccount<TData = Awaited<ReturnType<typeof getBankAccount>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankAccount>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBankAccountQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates a Bank Account with the given Id and Bank Account data
 * @summary Updates a Bank Account
 */
export const putApiGoCardlessGoCardlessBankAccountsId = (
    id: string,
    rightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoBankAccountDto>(
      {url: `/api/GoCardless/GoCardless/BankAccounts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto
    },
      options);
    }
  


export const getPutApiGoCardlessGoCardlessBankAccountsIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessBankAccountsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessBankAccountsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto>}, TContext> => {

const mutationKey = ['putApiGoCardlessGoCardlessBankAccountsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessBankAccountsId>>, {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiGoCardlessGoCardlessBankAccountsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiGoCardlessGoCardlessBankAccountsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessBankAccountsId>>>
    export type PutApiGoCardlessGoCardlessBankAccountsIdMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto>
    export type PutApiGoCardlessGoCardlessBankAccountsIdMutationError = ErrorType<string>

    /**
 * @summary Updates a Bank Account
 */
export const usePutApiGoCardlessGoCardlessBankAccountsId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessBankAccountsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiGoCardlessGoCardlessBankAccountsId>>,
        TError,
        {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestBaseDto>},
        TContext
      > => {

      const mutationOptions = getPutApiGoCardlessGoCardlessBankAccountsIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Retrieves a list of events from the database
 * @summary Retrieves a list of events
 */
export const getApiGoCardlessGoCardlessEvents = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoEventDto[]>(
      {url: `/api/GoCardless/GoCardless/Events`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessEventsQueryKey = () => {
    return [`/api/GoCardless/GoCardless/Events`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessEventsQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEvents>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEvents>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessEventsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEvents>>> = ({ signal }) => getApiGoCardlessGoCardlessEvents(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEvents>>>
export type GetApiGoCardlessGoCardlessEventsQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of events
 */

export function useGetApiGoCardlessGoCardlessEvents<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEvents>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEvents>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessEventsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns an EventDto object
 * @summary Get an Event by Id
 */
export const getApiGoCardlessGoCardlessEventsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoEventDto>(
      {url: `/api/GoCardless/GoCardless/Events/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessEventsIdQueryKey = (id: string,) => {
    return [`/api/GoCardless/GoCardless/Events/${id}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessEventsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEventsId>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEventsId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessEventsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEventsId>>> = ({ signal }) => getApiGoCardlessGoCardlessEventsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEventsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessEventsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEventsId>>>
export type GetApiGoCardlessGoCardlessEventsIdQueryError = ErrorType<void>


/**
 * @summary Get an Event by Id
 */

export function useGetApiGoCardlessGoCardlessEventsId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEventsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessEventsId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessEventsIdQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of all mandates
 * @summary Gets all mandates
 */
export const getMandates = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoMandateDto[]>(
      {url: `/api/GoCardless/GoCardless/Mandates`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMandatesQueryKey = () => {
    return [`/api/GoCardless/GoCardless/Mandates`] as const;
    }

    
export const getGetMandatesQueryOptions = <TData = Awaited<ReturnType<typeof getMandates>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMandates>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMandatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMandates>>> = ({ signal }) => getMandates(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMandates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMandatesQueryResult = NonNullable<Awaited<ReturnType<typeof getMandates>>>
export type GetMandatesQueryError = ErrorType<void>


/**
 * @summary Gets all mandates
 */

export function useGetMandates<TData = Awaited<ReturnType<typeof getMandates>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMandates>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMandatesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new Mandate and returns the newly created Mandate
 * @summary Creates a new Mandate
 */
export const postApiGoCardlessGoCardlessMandates = (
    rightioGoCardlessAPIWrapperModelsDtoMandateRequestDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoMandateDto>(
      {url: `/api/GoCardless/GoCardless/Mandates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoMandateRequestDto, signal
    },
      options);
    }
  


export const getPostApiGoCardlessGoCardlessMandatesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessMandates>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessMandates>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestDto>}, TContext> => {

const mutationKey = ['postApiGoCardlessGoCardlessMandates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessMandates>>, {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiGoCardlessGoCardlessMandates(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGoCardlessGoCardlessMandatesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessMandates>>>
    export type PostApiGoCardlessGoCardlessMandatesMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestDto>
    export type PostApiGoCardlessGoCardlessMandatesMutationError = ErrorType<void>

    /**
 * @summary Creates a new Mandate
 */
export const usePostApiGoCardlessGoCardlessMandates = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessMandates>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGoCardlessGoCardlessMandates>>,
        TError,
        {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiGoCardlessGoCardlessMandatesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Gets a Mandate by its Id
 * @summary Gets a Mandate by its Id
 */
export const getApiGoCardlessGoCardlessMandatesId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoMandateDto>(
      {url: `/api/GoCardless/GoCardless/Mandates/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessMandatesIdQueryKey = (id: string,) => {
    return [`/api/GoCardless/GoCardless/Mandates/${id}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessMandatesIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessMandatesId>>, TError = ErrorType<string>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessMandatesId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessMandatesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessMandatesId>>> = ({ signal }) => getApiGoCardlessGoCardlessMandatesId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessMandatesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessMandatesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessMandatesId>>>
export type GetApiGoCardlessGoCardlessMandatesIdQueryError = ErrorType<string>


/**
 * @summary Gets a Mandate by its Id
 */

export function useGetApiGoCardlessGoCardlessMandatesId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessMandatesId>>, TError = ErrorType<string>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessMandatesId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessMandatesIdQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates an existing Mandate with the given id and returns the updated MandateDto object
 * @summary Updates an existing Mandate with the given id
 */
export const putApiGoCardlessGoCardlessMandatesId = (
    id: string,
    rightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoMandateDto>(
      {url: `/api/GoCardless/GoCardless/Mandates/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto
    },
      options);
    }
  


export const getPutApiGoCardlessGoCardlessMandatesIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessMandatesId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessMandatesId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto>}, TContext> => {

const mutationKey = ['putApiGoCardlessGoCardlessMandatesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessMandatesId>>, {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiGoCardlessGoCardlessMandatesId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiGoCardlessGoCardlessMandatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessMandatesId>>>
    export type PutApiGoCardlessGoCardlessMandatesIdMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto>
    export type PutApiGoCardlessGoCardlessMandatesIdMutationError = ErrorType<string>

    /**
 * @summary Updates an existing Mandate with the given id
 */
export const usePutApiGoCardlessGoCardlessMandatesId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessMandatesId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiGoCardlessGoCardlessMandatesId>>,
        TError,
        {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoMandateRequestBaseDto>},
        TContext
      > => {

      const mutationOptions = getPutApiGoCardlessGoCardlessMandatesIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Cancels a mandate and returns the cancelled mandate
 * @summary Cancels a mandate
 */
export const deleteApiGoCardlessGoCardlessMandatesId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoMandateDto>(
      {url: `/api/GoCardless/GoCardless/Mandates/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiGoCardlessGoCardlessMandatesIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessMandatesId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessMandatesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiGoCardlessGoCardlessMandatesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessMandatesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiGoCardlessGoCardlessMandatesId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiGoCardlessGoCardlessMandatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessMandatesId>>>
    
    export type DeleteApiGoCardlessGoCardlessMandatesIdMutationError = ErrorType<string>

    /**
 * @summary Cancels a mandate
 */
export const useDeleteApiGoCardlessGoCardlessMandatesId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessMandatesId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessMandatesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiGoCardlessGoCardlessMandatesIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Retrieves a list of payments from the system
 * @summary Retrieves a list of payments
 */
export const getPayments = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoPaymentDto[]>(
      {url: `/api/GoCardless/GoCardless/Payments`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPaymentsQueryKey = () => {
    return [`/api/GoCardless/GoCardless/Payments`] as const;
    }

    
export const getGetPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getPayments>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayments>>> = ({ signal }) => getPayments(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayments>>>
export type GetPaymentsQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of payments
 */

export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPaymentsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new payment and returns the created payment
 * @summary Creates a new payment
 */
export const postApiGoCardlessGoCardlessPayments = (
    rightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoPaymentDto>(
      {url: `/api/GoCardless/GoCardless/Payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto, signal
    },
      options);
    }
  


export const getPostApiGoCardlessGoCardlessPaymentsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessPayments>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessPayments>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto>}, TContext> => {

const mutationKey = ['postApiGoCardlessGoCardlessPayments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessPayments>>, {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiGoCardlessGoCardlessPayments(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGoCardlessGoCardlessPaymentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessPayments>>>
    export type PostApiGoCardlessGoCardlessPaymentsMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto>
    export type PostApiGoCardlessGoCardlessPaymentsMutationError = ErrorType<void>

    /**
 * @summary Creates a new payment
 */
export const usePostApiGoCardlessGoCardlessPayments = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessPayments>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGoCardlessGoCardlessPayments>>,
        TError,
        {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiGoCardlessGoCardlessPaymentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Returns a PaymentDto object
 * @summary Get a payment by its id
 */
export const getApiGoCardlessGoCardlessPaymentsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoPaymentDto>(
      {url: `/api/GoCardless/GoCardless/Payments/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessPaymentsIdQueryKey = (id: string,) => {
    return [`/api/GoCardless/GoCardless/Payments/${id}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessPaymentsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessPaymentsId>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessPaymentsId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessPaymentsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessPaymentsId>>> = ({ signal }) => getApiGoCardlessGoCardlessPaymentsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessPaymentsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessPaymentsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessPaymentsId>>>
export type GetApiGoCardlessGoCardlessPaymentsIdQueryError = ErrorType<void>


/**
 * @summary Get a payment by its id
 */

export function useGetApiGoCardlessGoCardlessPaymentsId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessPaymentsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessPaymentsId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessPaymentsIdQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates a payment with the provided information.
 * @summary Updates a payment
 */
export const putApiGoCardlessGoCardlessPaymentsId = (
    id: string,
    rightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoPaymentDto>(
      {url: `/api/GoCardless/GoCardless/Payments/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto
    },
      options);
    }
  


export const getPutApiGoCardlessGoCardlessPaymentsIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessPaymentsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessPaymentsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto>}, TContext> => {

const mutationKey = ['putApiGoCardlessGoCardlessPaymentsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessPaymentsId>>, {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiGoCardlessGoCardlessPaymentsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiGoCardlessGoCardlessPaymentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessPaymentsId>>>
    export type PutApiGoCardlessGoCardlessPaymentsIdMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto>
    export type PutApiGoCardlessGoCardlessPaymentsIdMutationError = ErrorType<string>

    /**
 * @summary Updates a payment
 */
export const usePutApiGoCardlessGoCardlessPaymentsId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessPaymentsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiGoCardlessGoCardlessPaymentsId>>,
        TError,
        {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoPaymentRequestBaseDto>},
        TContext
      > => {

      const mutationOptions = getPutApiGoCardlessGoCardlessPaymentsIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Cancels a payment and returns the cancelled payment
 * @summary Cancels a payment
 */
export const deleteApiGoCardlessGoCardlessPaymentsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoPaymentDto>(
      {url: `/api/GoCardless/GoCardless/Payments/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiGoCardlessGoCardlessPaymentsIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessPaymentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessPaymentsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiGoCardlessGoCardlessPaymentsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessPaymentsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiGoCardlessGoCardlessPaymentsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiGoCardlessGoCardlessPaymentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessPaymentsId>>>
    
    export type DeleteApiGoCardlessGoCardlessPaymentsIdMutationError = ErrorType<string>

    /**
 * @summary Cancels a payment
 */
export const useDeleteApiGoCardlessGoCardlessPaymentsId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessPaymentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessPaymentsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiGoCardlessGoCardlessPaymentsIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Retrieves a list of all refunds from the database.
 * @summary Retrieves a list of all refunds
 */
export const getApiGoCardlessGoCardlessRefunds = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoRefundDto[]>(
      {url: `/api/GoCardless/GoCardless/Refunds`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessRefundsQueryKey = () => {
    return [`/api/GoCardless/GoCardless/Refunds`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessRefundsQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessRefunds>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessRefunds>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessRefundsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessRefunds>>> = ({ signal }) => getApiGoCardlessGoCardlessRefunds(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessRefunds>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessRefundsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessRefunds>>>
export type GetApiGoCardlessGoCardlessRefundsQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of all refunds
 */

export function useGetApiGoCardlessGoCardlessRefunds<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessRefunds>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessRefunds>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessRefundsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a refund by its id
 * @summary Gets a refund by its id
 */
export const getRefund = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoRefundDto>(
      {url: `/api/GoCardless/GoCardless/Refunds/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRefundQueryKey = (id: string,) => {
    return [`/api/GoCardless/GoCardless/Refunds/${id}`] as const;
    }

    
export const getGetRefundQueryOptions = <TData = Awaited<ReturnType<typeof getRefund>>, TError = ErrorType<string>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefund>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRefundQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRefund>>> = ({ signal }) => getRefund(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRefund>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRefundQueryResult = NonNullable<Awaited<ReturnType<typeof getRefund>>>
export type GetRefundQueryError = ErrorType<string>


/**
 * @summary Gets a refund by its id
 */

export function useGetRefund<TData = Awaited<ReturnType<typeof getRefund>>, TError = ErrorType<string>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRefund>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRefundQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates a refund with the provided information.
 * @summary Updates a refund
 */
export const putApiGoCardlessGoCardlessRefundsId = (
    id: string,
    rightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoRefundDto>(
      {url: `/api/GoCardless/GoCardless/Refunds/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto
    },
      options);
    }
  


export const getPutApiGoCardlessGoCardlessRefundsIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessRefundsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessRefundsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto>}, TContext> => {

const mutationKey = ['putApiGoCardlessGoCardlessRefundsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessRefundsId>>, {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiGoCardlessGoCardlessRefundsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiGoCardlessGoCardlessRefundsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessRefundsId>>>
    export type PutApiGoCardlessGoCardlessRefundsIdMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto>
    export type PutApiGoCardlessGoCardlessRefundsIdMutationError = ErrorType<void>

    /**
 * @summary Updates a refund
 */
export const usePutApiGoCardlessGoCardlessRefundsId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessRefundsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiGoCardlessGoCardlessRefundsId>>,
        TError,
        {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoRefundRequestBaseDto>},
        TContext
      > => {

      const mutationOptions = getPutApiGoCardlessGoCardlessRefundsIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Retrieves a list of all subscriptions
 * @summary Gets all subscriptions
 */
export const getSubscriptions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoSubscriptionDto[]>(
      {url: `/api/GoCardless/GoCardless/Subscriptions`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSubscriptionsQueryKey = () => {
    return [`/api/GoCardless/GoCardless/Subscriptions`] as const;
    }

    
export const getGetSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptions>>> = ({ signal }) => getSubscriptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptions>>>
export type GetSubscriptionsQueryError = ErrorType<void>


/**
 * @summary Gets all subscriptions
 */

export function useGetSubscriptions<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new subscription and returns the created subscription
 * @summary Creates a new subscription
 */
export const postApiGoCardlessGoCardlessSubscriptions = (
    rightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoSubscriptionDto>(
      {url: `/api/GoCardless/GoCardless/Subscriptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto, signal
    },
      options);
    }
  


export const getPostApiGoCardlessGoCardlessSubscriptionsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptions>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptions>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto>}, TContext> => {

const mutationKey = ['postApiGoCardlessGoCardlessSubscriptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptions>>, {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiGoCardlessGoCardlessSubscriptions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGoCardlessGoCardlessSubscriptionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptions>>>
    export type PostApiGoCardlessGoCardlessSubscriptionsMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto>
    export type PostApiGoCardlessGoCardlessSubscriptionsMutationError = ErrorType<string>

    /**
 * @summary Creates a new subscription
 */
export const usePostApiGoCardlessGoCardlessSubscriptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptions>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptions>>,
        TError,
        {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiGoCardlessGoCardlessSubscriptionsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Retrieves a list of all subscriptions for a given customer
 * @summary Gets all subscriptions for a given customer
 */
export const getSubscriptionsByCustomerId = (
    customerId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoSubscriptionDto[]>(
      {url: `/api/GoCardless/GoCardless/Subscriptions/ByCustomerId/${customerId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSubscriptionsByCustomerIdQueryKey = (customerId: string,) => {
    return [`/api/GoCardless/GoCardless/Subscriptions/ByCustomerId/${customerId}`] as const;
    }

    
export const getGetSubscriptionsByCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionsByCustomerId>>, TError = ErrorType<void>>(customerId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByCustomerId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsByCustomerIdQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionsByCustomerId>>> = ({ signal }) => getSubscriptionsByCustomerId(customerId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByCustomerId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionsByCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionsByCustomerId>>>
export type GetSubscriptionsByCustomerIdQueryError = ErrorType<void>


/**
 * @summary Gets all subscriptions for a given customer
 */

export function useGetSubscriptionsByCustomerId<TData = Awaited<ReturnType<typeof getSubscriptionsByCustomerId>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByCustomerId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSubscriptionsByCustomerIdQueryOptions(customerId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a subscription by its id and returns a SubscriptionDto object
 * @summary Gets a subscription by its id
 */
export const getApiGoCardlessGoCardlessSubscriptionsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoSubscriptionDto>(
      {url: `/api/GoCardless/GoCardless/Subscriptions/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessSubscriptionsIdQueryKey = (id: string,) => {
    return [`/api/GoCardless/GoCardless/Subscriptions/${id}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessSubscriptionsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSubscriptionsId>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSubscriptionsId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessSubscriptionsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSubscriptionsId>>> = ({ signal }) => getApiGoCardlessGoCardlessSubscriptionsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSubscriptionsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessSubscriptionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSubscriptionsId>>>
export type GetApiGoCardlessGoCardlessSubscriptionsIdQueryError = ErrorType<void>


/**
 * @summary Gets a subscription by its id
 */

export function useGetApiGoCardlessGoCardlessSubscriptionsId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSubscriptionsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSubscriptionsId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessSubscriptionsIdQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates an existing subscription with the provided data
 * @summary Updates an existing subscription
 */
export const putApiGoCardlessGoCardlessSubscriptionsId = (
    id: string,
    rightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoSubscriptionDto>(
      {url: `/api/GoCardless/GoCardless/Subscriptions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto
    },
      options);
    }
  


export const getPutApiGoCardlessGoCardlessSubscriptionsIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessSubscriptionsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessSubscriptionsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto>}, TContext> => {

const mutationKey = ['putApiGoCardlessGoCardlessSubscriptionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessSubscriptionsId>>, {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiGoCardlessGoCardlessSubscriptionsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiGoCardlessGoCardlessSubscriptionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessSubscriptionsId>>>
    export type PutApiGoCardlessGoCardlessSubscriptionsIdMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto>
    export type PutApiGoCardlessGoCardlessSubscriptionsIdMutationError = ErrorType<string>

    /**
 * @summary Updates an existing subscription
 */
export const usePutApiGoCardlessGoCardlessSubscriptionsId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGoCardlessGoCardlessSubscriptionsId>>, TError,{id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiGoCardlessGoCardlessSubscriptionsId>>,
        TError,
        {id: string;data: BodyType<RightioGoCardlessAPIWrapperModelsDtoSubscriptionRequestBaseDto>},
        TContext
      > => {

      const mutationOptions = getPutApiGoCardlessGoCardlessSubscriptionsIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Cancels a subscription and returns the cancelled subscription
 * @summary Cancels a subscription
 */
export const deleteApiGoCardlessGoCardlessSubscriptionsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoSubscriptionDto>(
      {url: `/api/GoCardless/GoCardless/Subscriptions/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiGoCardlessGoCardlessSubscriptionsIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessSubscriptionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessSubscriptionsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiGoCardlessGoCardlessSubscriptionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessSubscriptionsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiGoCardlessGoCardlessSubscriptionsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiGoCardlessGoCardlessSubscriptionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessSubscriptionsId>>>
    
    export type DeleteApiGoCardlessGoCardlessSubscriptionsIdMutationError = ErrorType<string>

    /**
 * @summary Cancels a subscription
 */
export const useDeleteApiGoCardlessGoCardlessSubscriptionsId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessSubscriptionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessSubscriptionsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiGoCardlessGoCardlessSubscriptionsIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Creates a new subscription and returns the created subscription
 * @summary Creates a new subscription
 */
export const postApiGoCardlessGoCardlessSubscriptionsByParams = (
    params: PostApiGoCardlessGoCardlessSubscriptionsByParamsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoSubscriptionDto>(
      {url: `/api/GoCardless/GoCardless/Subscriptions/ByParams`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiGoCardlessGoCardlessSubscriptionsByParamsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptionsByParams>>, TError,{params: PostApiGoCardlessGoCardlessSubscriptionsByParamsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptionsByParams>>, TError,{params: PostApiGoCardlessGoCardlessSubscriptionsByParamsParams}, TContext> => {

const mutationKey = ['postApiGoCardlessGoCardlessSubscriptionsByParams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptionsByParams>>, {params: PostApiGoCardlessGoCardlessSubscriptionsByParamsParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiGoCardlessGoCardlessSubscriptionsByParams(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGoCardlessGoCardlessSubscriptionsByParamsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptionsByParams>>>
    
    export type PostApiGoCardlessGoCardlessSubscriptionsByParamsMutationError = ErrorType<string>

    /**
 * @summary Creates a new subscription
 */
export const usePostApiGoCardlessGoCardlessSubscriptionsByParams = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptionsByParams>>, TError,{params: PostApiGoCardlessGoCardlessSubscriptionsByParamsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSubscriptionsByParams>>,
        TError,
        {params: PostApiGoCardlessGoCardlessSubscriptionsByParamsParams},
        TContext
      > => {

      const mutationOptions = getPostApiGoCardlessGoCardlessSubscriptionsByParamsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Logs an error response from the GoCardless API and returns the ID of the logged error.
 * @summary Logs an error response from the GoCardless API.
 */
export const postApiGoCardlessGoCardlessLogError = (
    rightioGoCardlessAPIWrapperModelsCommonErrorResponse: BodyType<RightioGoCardlessAPIWrapperModelsCommonErrorResponse>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/GoCardless/GoCardless/LogError`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsCommonErrorResponse, signal
    },
      options);
    }
  


export const getPostApiGoCardlessGoCardlessLogErrorMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessLogError>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsCommonErrorResponse>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessLogError>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsCommonErrorResponse>}, TContext> => {

const mutationKey = ['postApiGoCardlessGoCardlessLogError'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessLogError>>, {data: BodyType<RightioGoCardlessAPIWrapperModelsCommonErrorResponse>}> = (props) => {
          const {data} = props ?? {};

          return  postApiGoCardlessGoCardlessLogError(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGoCardlessGoCardlessLogErrorMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessLogError>>>
    export type PostApiGoCardlessGoCardlessLogErrorMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsCommonErrorResponse>
    export type PostApiGoCardlessGoCardlessLogErrorMutationError = ErrorType<void>

    /**
 * @summary Logs an error response from the GoCardless API.
 */
export const usePostApiGoCardlessGoCardlessLogError = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessLogError>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsCommonErrorResponse>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGoCardlessGoCardlessLogError>>,
        TError,
        {data: BodyType<RightioGoCardlessAPIWrapperModelsCommonErrorResponse>},
        TContext
      > => {

      const mutationOptions = getPostApiGoCardlessGoCardlessLogErrorMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Cancels Direct Debit and returns true if the Direct Debit was cancelled successfully
 * @summary Cancels Direct Debit
 */
export const deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId = (
    customerId: string,
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<boolean>(
      {url: `/api/GoCardless/GoCardless/DirectDebit/${customerId}/${subscriptionId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId>>, TError,{customerId: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId>>, TError,{customerId: string;subscriptionId: string}, TContext> => {

const mutationKey = ['deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId>>, {customerId: string;subscriptionId: string}> = (props) => {
          const {customerId,subscriptionId} = props ?? {};

          return  deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId(customerId,subscriptionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId>>>
    
    export type DeleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionIdMutationError = ErrorType<string>

    /**
 * @summary Cancels Direct Debit
 */
export const useDeleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId>>, TError,{customerId: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionId>>,
        TError,
        {customerId: string;subscriptionId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiGoCardlessGoCardlessDirectDebitCustomerIdSubscriptionIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Creates a new Direct Debit and returns the created Direct Debit
 * @summary Creates a new Direct Debit
 */
export const postApiGoCardlessGoCardlessDirectDebit = (
    careClubCCMAPIModelsDtoDirectDebitRequestDto: BodyType<CareClubCCMAPIModelsDtoDirectDebitRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsCreateDirectDebitResponse>(
      {url: `/api/GoCardless/GoCardless/DirectDebit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoDirectDebitRequestDto, signal
    },
      options);
    }
  


export const getPostApiGoCardlessGoCardlessDirectDebitMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebit>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoDirectDebitRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebit>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoDirectDebitRequestDto>}, TContext> => {

const mutationKey = ['postApiGoCardlessGoCardlessDirectDebit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebit>>, {data: BodyType<CareClubCCMAPIModelsDtoDirectDebitRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiGoCardlessGoCardlessDirectDebit(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGoCardlessGoCardlessDirectDebitMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebit>>>
    export type PostApiGoCardlessGoCardlessDirectDebitMutationBody = BodyType<CareClubCCMAPIModelsDtoDirectDebitRequestDto>
    export type PostApiGoCardlessGoCardlessDirectDebitMutationError = ErrorType<string>

    /**
 * @summary Creates a new Direct Debit
 */
export const usePostApiGoCardlessGoCardlessDirectDebit = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebit>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoDirectDebitRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebit>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsDtoDirectDebitRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiGoCardlessGoCardlessDirectDebitMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Processes a Direct Debit and returns the processed Direct Debit
 * @summary Processes a Direct Debit
 */
export const postApiGoCardlessGoCardlessDirectDebitServiceAgreementId = (
    serviceAgreementId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsCreateDirectDebitResponse>(
      {url: `/api/GoCardless/GoCardless/DirectDebit/${serviceAgreementId}`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiGoCardlessGoCardlessDirectDebitServiceAgreementIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebitServiceAgreementId>>, TError,{serviceAgreementId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebitServiceAgreementId>>, TError,{serviceAgreementId: number}, TContext> => {

const mutationKey = ['postApiGoCardlessGoCardlessDirectDebitServiceAgreementId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebitServiceAgreementId>>, {serviceAgreementId: number}> = (props) => {
          const {serviceAgreementId} = props ?? {};

          return  postApiGoCardlessGoCardlessDirectDebitServiceAgreementId(serviceAgreementId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGoCardlessGoCardlessDirectDebitServiceAgreementIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebitServiceAgreementId>>>
    
    export type PostApiGoCardlessGoCardlessDirectDebitServiceAgreementIdMutationError = ErrorType<string>

    /**
 * @summary Processes a Direct Debit
 */
export const usePostApiGoCardlessGoCardlessDirectDebitServiceAgreementId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebitServiceAgreementId>>, TError,{serviceAgreementId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGoCardlessGoCardlessDirectDebitServiceAgreementId>>,
        TError,
        {serviceAgreementId: number},
        TContext
      > => {

      const mutationOptions = getPostApiGoCardlessGoCardlessDirectDebitServiceAgreementIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Simulates a mandate state and returns the simulated scenario id
 * @summary Simulates a mandate state
 */
export const getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId = (
    scenarioId: string,
    mandateId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/GoCardless/GoCardless/SimulateMandateState/${scenarioId}/${mandateId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateIdQueryKey = (scenarioId: string,
    mandateId: string,) => {
    return [`/api/GoCardless/GoCardless/SimulateMandateState/${scenarioId}/${mandateId}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId>>, TError = ErrorType<string>>(scenarioId: string,
    mandateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateIdQueryKey(scenarioId,mandateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId>>> = ({ signal }) => getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId(scenarioId,mandateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scenarioId && mandateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId>>>
export type GetApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateIdQueryError = ErrorType<string>


/**
 * @summary Simulates a mandate state
 */

export function useGetApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId>>, TError = ErrorType<string>>(
 scenarioId: string,
    mandateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessSimulateMandateStateScenarioIdMandateIdQueryOptions(scenarioId,mandateId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Simulates a payment state and returns the simulated scenario id
 * @summary Simulates a payment state
 */
export const getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId = (
    scenarioId: string,
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/GoCardless/GoCardless/SimulatePaymentState/${scenarioId}/${paymentId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentIdQueryKey = (scenarioId: string,
    paymentId: string,) => {
    return [`/api/GoCardless/GoCardless/SimulatePaymentState/${scenarioId}/${paymentId}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId>>, TError = ErrorType<string>>(scenarioId: string,
    paymentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentIdQueryKey(scenarioId,paymentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId>>> = ({ signal }) => getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId(scenarioId,paymentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scenarioId && paymentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId>>>
export type GetApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentIdQueryError = ErrorType<string>


/**
 * @summary Simulates a payment state
 */

export function useGetApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId>>, TError = ErrorType<string>>(
 scenarioId: string,
    paymentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessSimulatePaymentStateScenarioIdPaymentIdQueryOptions(scenarioId,paymentId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Simulates a payout state and returns the simulated scenario id
 * @summary Simulates a payout state
 */
export const getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId = (
    scenarioId: string,
    payoutId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/GoCardless/GoCardless/SimulatePayoutState/${scenarioId}/${payoutId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutIdQueryKey = (scenarioId: string,
    payoutId: string,) => {
    return [`/api/GoCardless/GoCardless/SimulatePayoutState/${scenarioId}/${payoutId}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId>>, TError = ErrorType<string>>(scenarioId: string,
    payoutId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutIdQueryKey(scenarioId,payoutId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId>>> = ({ signal }) => getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId(scenarioId,payoutId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scenarioId && payoutId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId>>>
export type GetApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutIdQueryError = ErrorType<string>


/**
 * @summary Simulates a payout state
 */

export function useGetApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId>>, TError = ErrorType<string>>(
 scenarioId: string,
    payoutId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessSimulatePayoutStateScenarioIdPayoutIdQueryOptions(scenarioId,payoutId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Simulates a refund state and returns the simulated scenario id
 * @summary Simulates a refund state
 */
export const getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId = (
    scenarioId: string,
    refundId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/GoCardless/GoCardless/SimulateRefundState/${scenarioId}/${refundId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundIdQueryKey = (scenarioId: string,
    refundId: string,) => {
    return [`/api/GoCardless/GoCardless/SimulateRefundState/${scenarioId}/${refundId}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId>>, TError = ErrorType<string>>(scenarioId: string,
    refundId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundIdQueryKey(scenarioId,refundId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId>>> = ({ signal }) => getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId(scenarioId,refundId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scenarioId && refundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId>>>
export type GetApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundIdQueryError = ErrorType<string>


/**
 * @summary Simulates a refund state
 */

export function useGetApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId>>, TError = ErrorType<string>>(
 scenarioId: string,
    refundId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessSimulateRefundStateScenarioIdRefundIdQueryOptions(scenarioId,refundId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Simulates a billing request state and returns the simulated scenario id
 * @summary Simulates a billing request state
 */
export const getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId = (
    scenarioId: string,
    billingRequestId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/GoCardless/GoCardless/SimulateBillingRequestState/${scenarioId}/${billingRequestId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestIdQueryKey = (scenarioId: string,
    billingRequestId: string,) => {
    return [`/api/GoCardless/GoCardless/SimulateBillingRequestState/${scenarioId}/${billingRequestId}`] as const;
    }

    
export const getGetApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId>>, TError = ErrorType<string>>(scenarioId: string,
    billingRequestId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestIdQueryKey(scenarioId,billingRequestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId>>> = ({ signal }) => getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId(scenarioId,billingRequestId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scenarioId && billingRequestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId>>>
export type GetApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestIdQueryError = ErrorType<string>


/**
 * @summary Simulates a billing request state
 */

export function useGetApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId<TData = Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId>>, TError = ErrorType<string>>(
 scenarioId: string,
    billingRequestId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGoCardlessGoCardlessSimulateBillingRequestStateScenarioIdBillingRequestIdQueryOptions(scenarioId,billingRequestId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Simulates a payment and returns the simulated payment
 * @summary Simulates a payment.
 */
export const postApiGoCardlessGoCardlessSimulatePayment = (
    rightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoPaymentDto>(
      {url: `/api/GoCardless/GoCardless/SimulatePayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto, signal
    },
      options);
    }
  


export const getPostApiGoCardlessGoCardlessSimulatePaymentMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSimulatePayment>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSimulatePayment>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto>}, TContext> => {

const mutationKey = ['postApiGoCardlessGoCardlessSimulatePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSimulatePayment>>, {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiGoCardlessGoCardlessSimulatePayment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGoCardlessGoCardlessSimulatePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSimulatePayment>>>
    export type PostApiGoCardlessGoCardlessSimulatePaymentMutationBody = BodyType<RightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto>
    export type PostApiGoCardlessGoCardlessSimulatePaymentMutationError = ErrorType<string>

    /**
 * @summary Simulates a payment.
 */
export const usePostApiGoCardlessGoCardlessSimulatePayment = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSimulatePayment>>, TError,{data: BodyType<RightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGoCardlessGoCardlessSimulatePayment>>,
        TError,
        {data: BodyType<RightioGoCardlessAPIWrapperModelsDtoDevelopmentPaymentDto>},
        TContext
      > => {

      const mutationOptions = getPostApiGoCardlessGoCardlessSimulatePaymentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    